import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import api from "../../../api/axiosInstance";

const StatsSection = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get("/api/stats");
        setStats(res.data);
      } catch (err) {
        console.error("Failed to load stats", err);
      }
    };

    fetchStats();
  }, []);

  if (!stats) return null;

  const statsUI = [
    {
      id: 1,
      icon: "Users",
      value: `${stats.totalStudents?.toLocaleString()}+`,
      label: "Active Students",
      description: "Professionals trust our platform",
      color: "var(--color-primary)",
    },
    {
      id: 2,
      icon: "Award",
      value: `${stats.successRate}%`,
      label: "Success Rate",
      description: "Students land their target jobs",
      color: "var(--color-success)",
    },
    {
      id: 3,
      icon: "BookOpen",
      value: `${stats.expertCourses}+`,
      label: "Expert Courses",
      description: "Comprehensive learning paths",
      color: "var(--color-accent)",
    },
    {
      id: 4,
      icon: "Star",
      value: `${stats.rating}/5`,
      label: "Average Rating",
      description: "Based on student feedback",
      color: "var(--color-warning)",
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {statsUI.map((stat) => (
            <div
              key={stat.id}
              className="bg-card rounded-xl p-6 md:p-8 text-center shadow-md border border-border"
            >
              <div
                className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: `${stat.color}15` }}
              >
                <Icon name={stat.icon} size={28} color={stat.color} />
              </div>

              <div className="text-3xl md:text-4xl font-bold mb-2">
                {stat.value}
              </div>

              <div className="text-base md:text-lg font-semibold mb-2">
                {stat.label}
              </div>

              <p className="text-sm text-muted-foreground">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
